<template>
    <info-screen
            class="startRegistration"
            :title="$ml.get('setFinishTitleReg')"
            :text="textInfo"
            :action="nextScreen"
            :buttonText="$ml.get('setFinishButtonReg')"
            titleH1
            :headerImg="8"
    >
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import Profile from '../../helpers/profile'

    export default {
        name: "finishRegistrationPage",
        components: {InfoScreen},
        computed: {
            textInfo: function () {
                return Profile.process === 'accessRecovery' ? this.$ml.get('accessRecoveryFinishText') : this.$ml.get('setFinishTextReg');
            }
        },
        methods: {
            nextScreen: function () {
                window.location = Profile.redirectTo;
            },
        }
    }
</script>

<style scoped>

</style>